import React, { useState } from "react";
import {
  Paper,
  Box,
  IconButton,
  TextField,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import MyTitle from "../../components/CardSection/MyTitle";
import { functions } from "../../config/firebaseConfig";
import { httpsCallable } from "firebase/functions";

const QuinItemEdit = () => {
  const [open, setOpen] = useState(false);
  const [itemId, setItemId] = useState("");
  const [name, setName] = useState("");
  const [prix, setPrix] = useState("");
  const [status, setStatus] = useState("idle");
  const [message, setMessage] = useState("");

  const reset = () => {
    setName("");
    setPrix("");
    setStatus("idle");
    setMessage("");
  };

  const handleSearch = async () => {
    if (!itemId) return;
    setStatus("searching");
    reset();
    try {
      const lookup = httpsCallable(functions, "quinLookup");
      const result = await lookup({ id: itemId });
      const value = String(result.data.value ?? "");
      const lastUnderscore = value.lastIndexOf("_");
      if (lastUnderscore === -1) {
        setName(value);
        setPrix("");
      } else {
        setName(value.substring(0, lastUnderscore));
        setPrix(value.substring(lastUnderscore + 1));
      }
      setStatus("found");
    } catch (e) {
      setStatus("error");
      setMessage(
        e?.code === "functions/not-found"
          ? "Article introuvable"
          : "Erreur de recherche",
      );
    }
  };

  const handleSave = async () => {
    if (!itemId || !name || !prix) return;
    setStatus("saving");
    setMessage("");
    try {
      const update = httpsCallable(functions, "quinUpdateItem");
      await update({ id: itemId, name: name.trim(), prix: prix.trim() });
      setStatus("saved");
      setMessage("Modifié avec succès");
      setItemId("");
      setName("");
      setPrix("");
    } catch (e) {
      setStatus("error");
      setMessage("Erreur lors de la modification");
    }
  };

  const isFound = status === "found" || status === "saving" || status === "saved";

  return (
    <Paper elevation={0} variant="outlined" sx={{ mt: 2, p: 1 }}>
      <Box
        onClick={() => setOpen((v) => !v)}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
          borderRadius: 1,
          p: 0.5,
          "&:hover": { backgroundColor: "action.hover" },
        }}
      >
        <MyTitle text="MODIFIER ARTICLE" />
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            setOpen((v) => !v);
          }}
        >
          {open ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
      </Box>

      {open && (
        <Box
          onClick={(e) => e.stopPropagation()}
          sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 0.5, px: 1.5, pb: 1 }}
        >
          <Box display="flex" gap={1}>
            <TextField
              size="small"
              sx={{ flex: 1 }}
              label="ID article"
              value={itemId}
              onChange={(e) => {
                setItemId(e.target.value);
                reset();
              }}
              onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            />
            <Button
              variant="contained"
              onClick={handleSearch}
              disabled={!itemId || status === "searching"}
              sx={{ flex: 1 }}
            >
              {status === "searching" ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                "Rechercher"
              )}
            </Button>
          </Box>

          {isFound && (
            <>
              <TextField
                size="small"
                fullWidth
                label="Nom"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <TextField
                size="small"
                fullWidth
                label="Prix (CDF)"
                value={prix}
                onChange={(e) => setPrix(e.target.value)}
                placeholder="7,08"
              />
              <Button
                variant="contained"
                color="primary"
                onClick={handleSave}
                disabled={!name || !prix || status === "saving"}
              >
                {status === "saving" ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  "Modifier"
                )}
              </Button>
            </>
          )}

          {message && (
            <Typography
              variant="body2"
              color={status === "saved" ? "success.main" : "error"}
            >
              {message}
            </Typography>
          )}
        </Box>
      )}
    </Paper>
  );
};

export default QuinItemEdit;
